<template>
    <div class="navigation-main"
        :style="{ width: $pScreen.mainW }"
        @click="hideSomething">
        <login-in :loginType="loginType"
            :showLoginPop="true"
            :isLoginFlag="isLoginFlag"
            :activityUrl="activityUrl"></login-in>
        <div v-show="!searchResultShowFlag">
            <div style="position: fixed; top:0; left: 0; z-index: 1; background: #fff;"
                class="fixedMap">
                <div class="mapWrapper">
                    <!-- 地图容器 -->
                    <div id="mapContainer"
                        ref="mapContainer"
                        class="map-container"
                        :style="{ width: $pScreen.mainW, height: mapHeight + 'px' }"></div>

                    <!-- 搜索按钮 -->
                    <div v-show="loationShowFlag"
                        ref="searchBtn"
                        class="selectAddress flex">
                        <div class="locSuccess flex"
                            @click="openSearchContainer">
                            <img src="static/runtime/images/magic/search2.png"
                                alt />
                            <span>{{ selectedCity }}</span>
                        </div>
                    </div>

                    <!-- 我的定位按钮 -->
                    <div v-show="toLocationShowFlag"
                        ref="toLocation"
                        class="toLocation"
                        @click="restMyGetLocation">
                        <img src="static/runtime/images/magic/tolocation.png"
                            alt />
                    </div>

                    <!-- 大地图提示信息 -->
                    <div v-show="showShopMsg && !maximizeShowFlag">
                        <ul class="shopMsg2">
                            <li class="shopItemMax"
                                @click="toChannelPosition(seChannel, $event)">
                                <div class="flex"
                                    style="align-items: flex-end;">
                                    <p class="left-max handle-overflow"
                                        :style="{width: !(locateSuccessFlag && seChannel.distance && geolocationErrorCode !== 1)? '100%': ''}">
                                        <span class="store-type">
                                            {{ channelTypeList[Number(seChannel.channelType)] }}
                                        </span>
                                        <span class="store-name">{{ seChannel.channelName }}</span>
                                    </p>
                                    <p v-if="locateSuccessFlag && seChannel.distance && geolocationErrorCode !== 1"
                                        class="right-max"
                                        style="line-height: 24px;color: #999999;">
                                        距您{{ seChannel.distance }}km
                                    </p>
                                </div>
                                <div class="flex"
                                    style="justify-content: space-between; position: relative;color: #999999;"
                                    :style="{'min-height':hasNextActivityFlag && !(seChannel.sensitizationMobilephone || seChannel.telephone)? '32px' : ''}">
                                    <div style="width: 75%; align-items: flex-start;"
                                        class="fs-12 openMap flex "
                                        @click="openMap(seChannel)">
                                        <img style="margin-right: 5px;"
                                            class="iconStyle"
                                            src="../../../../static/runtime/images/magic/location_arrow.png"
                                            alt />
                                        <span class="handle-overflow"> {{ seChannel.channelAddress }}</span>
                                    </div>
                                    <div class="right-max">
                                        <div v-if="hasNextActivityFlag"
                                            class="nextStep"
                                            style=""
                                            @click="toNextActivity(seChannel)">
                                            {{ submitDocument }}
                                        </div>
                                    </div>

                                </div>
                                <div class="clearfix">
                                    <div class="left"
                                        style="float: left;">
                                        <a v-if="seChannel.sensitizationMobilephone || seChannel.telephone"
                                            class="flex"
                                            :href="'tel:' + (seChannel.sensitizationMobilephone || seChannel.telephone)">
                                            <img class="iconStyle"
                                                src="../../../../static/runtime/images/magic/phone.png"
                                                alt
                                                style="margin-right: 5px;" />
                                            <span class="fs-12">{{ seChannel.sensitizationMobilephone || seChannel.telephone }}</span>
                                        </a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <!-- 地图全屏按钮 -->
                    <div v-show="maximizeShowFlag"
                        ref="maximize"
                        class="maximize"
                        @click="maximize">
                        <img src="static/runtime/images/magic/fullscreen.png"
                            alt />
                    </div>

                    <!-- 地图退出全屏按钮 -->
                    <div v-show="minimizeShowFlag"
                        ref="minimize"
                        class="minimize"
                        @click="minimize">
                        <img src="static/runtime/images/magic/smalscreen.png"
                            alt />
                    </div>

                    <!-- 地图全屏时，顶部提示信息 -->
                    <div v-show="shopTipsShowFlag"
                        class="shopTips">
                        <span class="selectedCity">{{ selectedCity }}</span>有<span class="shopNum">{{ channelConut }}</span>家门店为您服务
                        <img class="deleteTips"
                            src="static/runtime/images/magic/close-icon-black.svg"
                            alt
                            @click="deleteTips" />
                    </div>
                </div>

                <!-- banner图 -->
                <div v-show="bannerShowFlag"
                    class="mapbanner">
                    <img :src="bannerSrc"
                        alt />
                    <div v-if="!screenTabShow && (channelList && channelList.length > 0 && maximizeShowFlag)"
                        class="bgcWall"></div>
                </div>

                <!-- 门店筛选组件 -->
                <div v-if="screenTabShow"
                    style="position: relative;">
                    <!-- 按钮区 -->
                    <div class="customSelect scale-1px">
                        <!-- 列表排序方式：离我最近、推荐排序 -->
                        <div v-if="sortConditionFlag"
                            class="sortItem"
                            :class="!isStore ? 'current' : ''"
                            @click="distanceChange">
                            {{ distanceSortCon }}
                        </div>
                        <!-- 门店筛选条件 -->
                        <div v-if="filterConditionFlag"
                            class="sortItem"
                            :class="isStore ? 'current' : ''"
                            @click="channelChange">
                            {{ channelSortCon }}
                            <span v-show="!channelContentShow"
                                class="downTriangle"></span>
                            <span v-show="channelContentShow"
                                class="upTriangle"></span>
                        </div>
                    </div>
                    <!-- 门店筛选下拉框 -->
                    <div v-show="channelContentShow"
                        class="screenWrapper">
                        <ul v-show="channelContentShow"
                            class="conidtionWrapper">
                            <li v-for="(item, index) in channelSortArr"
                                :key="index"
                                @click="chooseChannelType(item, index)">
                                <span :class="{ activeColor: channelCurrent == index }">{{ item.label }}</span>
                                <img v-show="channelCurrent == index"
                                    src="static/runtime/images/magic/yesMark.svg"
                                    alt />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- 门店列表 -->
            <div v-show="channelList && channelList.length > 0 && maximizeShowFlag"
                :style="{ 'margin-top': screenTabShow ? 'calc(356px + 24vw)' : 'calc(310px + 24vw)',
                  'min-height': screenTabShow ? 'calc(100vh - calc(356px + 24vw))' :'calc(100vh - calc(310px + 24vw))'}"
                class="storeList">
                <ul class="mainPageContainer">
                    <li v-for="(item, key) in channelList"
                        :key="key"
                        class="shopItem scale-1px"
                        :class="(isCheckedId == item.id && isCheckedIcon) ? 'isChecked' : 'noCheck'"
                        @click="toChannelPosition(item, $event)">
                        <div v-if="item.isRecent"
                            class="shortTag">距您最近</div>
                        <div style="width: 100%;">
                            <div class="flex"
                                style="justify-content: space-between;">
                                <div :style="{ width: !(item.distance && geolocationErrorCode !== 1)? '100%': '65%'}">
                                    <div class="left fs-14 ellipsis flex"
                                        style="width: 100%">
                                        <div class="store-type">
                                            {{ channelTypeList[Number(item.channelType)] }}
                                        </div>
                                        <div class="ellipsis"
                                            style="color: #000000;">{{ item.channelName }}</div>
                                    </div>
                                    <div class="flex"
                                        style="line-height: 20px; justify-content: space-between; margin-top: 5px; align-items: flex-start; position: relative;color: #999999;"
                                        :style="{'min-height':hasNextActivityFlag && !(item.sensitizationMobilephone || item.telephone)? '32px': ''}">
                                        <!-- 门店地址 -->
                                        <div :class="navigateOtherSet === '1'? 'additionalArea':''"
                                            class="fs-12 flex"
                                            @click="openMap(item)">
                                            <p>{{ item.channelAddress }}</p>
                                        </div>

                                    </div>
                                    <!-- 门店联系电话 -->
                                    <div class="clearfix">
                                        <p v-if="item.sensitizationMobilephone || item.telephone"
                                            class="left"
                                            style="width: 70%; float: left;">
                                            <a class="additionalArea fs-12 flex"
                                                :href="'tel:' + (item.sensitizationMobilephone || item.telephone)">
                                                <img class="iconStyle"
                                                    src="static/runtime/images/magic/phone.png"
                                                    alt
                                                    style="margin-right: 5px;" />
                                                {{ item.sensitizationMobilephone || item.telephone }}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                                <div v-if="item.distance && geolocationErrorCode !== 1"
                                    style="width: 1px;height: 60px;background:rgba(0,0,0,0.07);margin:0 15px"></div>
                                <div v-if="item.distance && geolocationErrorCode !== 1"
                                    style="width: 25%">
                                    <div class="right fs-12"
                                        style="line-height: 24px;color: #999999;width: 100%;text-align: center;">
                                        距您{{ item.distance }}km
                                    </div>
                                    <!-- 下级活动跳转按钮 -->
                                    <div v-if="hasNextActivityFlag"
                                        class="nextStep additionalArea"
                                        @click="toNextActivity(item)">
                                        {{ submitDocument }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <img v-if="isCheckedId == item.id && isCheckedIcon"
                            class="checkedIcon"
                            src="static/runtime/images/magic/checkIcon.svg"
                            alt />
                    </li>
                </ul>
            </div>

            <!-- 门店列表为空 -->
            <div v-show="loadedFlag && channelList && channelList.length == 0 && maximizeShowFlag"
                :style="{ 'margin-top': screenTabShow ? 'calc(356px + 24vw)' : 'calc(310px + 24vw)' }"
                style="padding-top: 70px;"
                class="noSearchData">
                <img src="static/runtime/images/magic/noStore.png"
                    alt />
                <p>没有符合条件的门店~</p>
            </div>
        </div>

        <!--搜索页面-->
        <section v-show="searchContainerShowFlag"
            class="searchContainer"
            @click="hidePanel">
            <div ref="searchContent"
                class="searchContent">
                <!-- 顶部搜索栏 -->
                <div class="headWrapper flex">
                    <div class="left flex"
                        @click="toggleCity">
                        <span class="selectedCity">{{ selectedCity.length > 3? selectedCity.substring(0, 2) + "...": selectedCity}}</span>
                        <img v-show="areaWrapperShowFlag"
                            src="static/runtime/images/magic/uparrow.png"
                            alt />
                        <img v-show="!areaWrapperShowFlag"
                            src="static/runtime/images/magic/downarrow.png"
                            alt />
                    </div>
                    <div class="middle">
                        <input v-model.trim="iptVal"
                            class="ipt"
                            type="text"
                            style="caret-color: #00B1FF;"
                            placeholder="请输入门店名称"
                            @focus="inptFocus"
                            @input="ipt($event)" />
                        <img v-show="iptVal"
                            class="clearIpt"
                            style="top: 2px;"
                            src="static/runtime/images/magic/delete.png"
                            alt
                            @click="clearIpt" />
                    </div>
                    <div v-show="!searchBtnShowFlag"
                        class="right close"
                        @click="close">
                        关闭
                    </div>
                    <div v-show="searchBtnShowFlag"
                        class="right search"
                        @click="search">
                        搜索
                    </div>
                </div>
                <!-- 省份、城市选择区域 -->
                <div v-show="areaWrapperShowFlag"
                    class="areaWrapper">
                    <img class="triangle"
                        src="static/runtime/images/magic/triangle.png"
                        alt />
                    <div class="location align-left scale-1px">
                        <span class="currentCity"
                            @click="selectGPSCity">{{ locationCity }}</span>
                        <span v-if="showGPS"
                            style="font-size: 10px;"
                            class="gray">GPS定位</span>
                    </div>
                    <div class="content">
                        <div class="province" :style="{height: provinceListAndCityListHeight + 'px'}">
                            <ul>
                                <li v-for="(item, key) in cityData"
                                    :key="key"
                                    class="item"
                                    :class="key == provinceSortNum ? 'provinceActive' : ''"
                                    @click="changeProvince(key)">
                                    <div class="provinceName scale-1px">
                                        {{ item.provinceName }}
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="city" :style="{height: provinceListAndCityListHeight + 'px'}">
                            <ul v-for="(items, key) in cityData"
                                v-show="key == citySortNum"
                                :key="key">
                                <li v-for="(item, key) in items.citys"
                                    :key="key"
                                    class="betweenFlex item scale-1px"
                                    @click="selectCity(item, key)">
                                    <span>{{ item.cityName }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--搜索结果页面-->
        <div v-show="searchResultShowFlag"
            class="searchResult">
            <div class="searchWrapper flex">
                <div class="left flex goback"
                    @click="goback">
                    <img src="static/runtime/images/magic/back.png"
                        alt />
                </div>
                <div class="middle flex">
                    <img class="searchImg"
                        src="static/runtime/images/magic/search.png"
                        alt />
                    <input v-model="iptVal"
                        class="ipt2"
                        type="text"
                        placeholder="请输入门店名称" />
                    <img v-show="iptVal"
                        class="clearIpt"
                        src="static/runtime/images/magic/delete.png"
                        alt
                        @click="clearIpt" />
                </div>
                <div class="right search2"
                    @click="search2">搜索</div>
            </div>

            <ul v-if="searchChannelList.length > 0"
                class="searchResultContainer">
                <li v-for="(item, key) in searchChannelList"
                    :key="key"
                    class="shopItem scale-1px">
                    <div class="flex">
                        <p class="left"
                            :style="{width: !(locateSuccessFlag &&item.distance != null && geolocationErrorCode !== 1)? '100%' : ''}">
                            <span class="store-type">
                                {{ channelTypeList[Number(item.channelType)] }}
                            </span>
                            <span style="color: #000000;">{{ item.channelName }}</span>
                        </p>
                        <p v-if="locateSuccessFlag && item.distance != null && geolocationErrorCode !== 1"
                            class="right fs-12"
                            style="line-height: 24px;color: #999999;">
                            {{ item.distance }}km
                        </p>
                    </div>
                    <div class="flex"
                        style="align-items: flex-start; line-height: 20px; justify-content: space-between; margin-top: 5px; position: relative;color: #999999;"
                        :style="{'min-height': hasNextActivityFlag && !(item.sensitizationMobilephone || item.telephone) ? '32px': ''}">
                        <div style="width: 70%; align-items: flex-start;"
                            class="fs-12 flex"
                            @click="openMap(item)">
                            <img style="margin: 3px 5px 0 0;"
                                class="iconStyle"
                                src="static/runtime/images/magic/location_arrow.png"
                                alt />
                            {{ item.channelAddress }}
                        </div>
                        <div v-if="hasNextActivityFlag"
                            class="nextStep"
                            @click="toNextActivity(item)">
                            {{ submitDocument }}
                        </div>
                    </div>
                    <div class="clearfix">
                        <p v-if="item.sensitizationMobilephone || item.telephone"
                            class="left"
                            style="float: left;">
                            <a :href="'tel:' + (item.sensitizationMobilephone || item.telephone)"
                                class="fs-12 flex">
                                <img class="iconStyle"
                                    src="static/runtime/images/magic/phone.png"
                                    alt
                                    style="margin-right: 5px;" />
                                {{ item.sensitizationMobilephone || item.telephone }}
                            </a>
                        </p>
                    </div>
                </li>
            </ul>

            <div v-if="searchChannelList.length == 0"
                class="noSearchData">
                <img src="static/runtime/images/magic/noStore.png"
                    alt />
                <p>没有符合条件的门店~</p>
            </div>
        </div>

        <!-- 纠错反馈遮罩层 -->
        <van-overlay :show="errorResponseShow"
            @click="handleErrorResponse(true)"></van-overlay>

        <!-- 纠错反馈 -->
        <div v-if="navCorrectFeedback"
            :class="`wrapper errorResponse ${errorResponseClass}`"
            @click="handleErrorResponse()">
            <img src="../../../../static/image/errorResponse.png">
        </div>

        <!-- 不正确客户端打开提示组件 -->
        <IncorrectClient :isDisplay="!isCorrectClient"
            :loginType="originLoginType"></IncorrectClient>
    </div>
</template>
<script>
import { TMap, getGeolocation, AMapLoaderNew, getLocationInfoByGeolocation } from './TMap';
import { Dialog, Overlay } from 'vant';
import utils from '../../../utils/comUtils';
import loginIn from './dynamicAttr/modal/login-in.vue';
import { noLoginHandler, jumpToMapNavigation, checkClient, getEnvMark } from './common-methods/utils';
import IncorrectClient from './dynamicAttr/incorrect-client.vue';
import { LoginType } from '../../../commons/commonVariables';
import { EnvMark } from './lucky-draw/common/global-variable';

export default {
  components: {
    [Overlay.name]: Overlay,
    loginIn,
    IncorrectClient,
  },
  props: {
    activityObj: Object,
  },
  data() {
    return {
      loginFlag: false,
      position: {
        index: 1,
        accuracy: 10010,
        adcode: '440300',
        addr: '',
        city: '北京市',
        district: '',
        lat: 39.915156,
        lng: 116.403883,
        module: 'geolocation',
        nation: '中国',
        province: '北京市',
        type: 'default',
      },
      getLocationCount: 0,
      locationCity: '无法获取当前位置',
      navigateOtherSet: '1', // 是否配置了“导航到门店”，“1”：是 “0”：否
      channelList: [],
      selectChannel: {},
      channelConut: 0,
      //定位api
      geolocation: {},
      center: '',
      code: '',
      mapEntity: {},
      myMarker: {},
      qqmaps: {},
      //地图选择的门店信息
      seMarker: {},
      //地图最大化选择的门店信息
      seChannel: { channelAddress: '', channelName: '' },
      markerCache: {},
      channelCache: {},
      //缓存点击过的城市，避免多次点击多次调用服务
      cityNameList: [],
      cityCahnnelCache: {},
      markers: [],
      cityData: [],
      searchChannelList: [],
      //选择的城市
      selectedCity: '',
      marker1SortNum: '',
      citySortNum: 0,
      provinceSortNum: 0,
      provinceListAndCityListHeight:120, // 省市列表高度，默认120px
      iptVal: '',
      //获取定位异常code
      geolocationErrorCode: -1,
      //是否设置过按最近显示地图缩放比例
      isInitSetRecent: false,
      //是否必须刷新地图
      isMastInit: false,
      showShopMsg: false,
      loationShowFlag: true,
      maximizeShowFlag: true,
      channelShowFlag: true,
      shopTipsShowFlag: false,
      toLocationShowFlag: false,
      minimizeShowFlag: false,
      searchContainerShowFlag: false,
      areaWrapperShowFlag: true,
      searchBtnShowFlag: false,
      searchResultShowFlag: false,
      bannerShowFlag: true,
      locateSuccessFlag: false,
      distanceContentShow: false,
      channelContentShow: false,
      screenTabShow: false,
      sortConditionFlag: false,
      filterConditionFlag: false,
      loadedFlag: false,
      hasNextActivityFlag: false,
      distanceCurrent: 666,
      channelCurrent: 666,
      distanceSortArr: [
        { value: 'distanceSorting', label: '离我最近' },
        { value: 'recommendationSorting', label: '推荐排序' },
      ],
      channelSortArr: [],
      selectedDistanceSortType: '',
      selectedChannelSortType: '',
      bannerSrc: '',
      nextActivityCode: '',
      distanceSortCon: '门店排序',
      channelSortCon: '门店筛选',
      noLocationFlag: false, // 是否获取到位置信息（非默认位置）true-默认位置,false-非默认位置
      isDisabled: false,
      showGPS: true,
      getUserLocationFlag: true,
      submitDocument: '选门店',
      mapMakers: [], //地图标记点
      shareRecordId: '', //小程序活动邀请有礼进入携带分享id
      shareGiftFlag: false, // 是否从小程序活动邀请有礼进入
      errorResponseClass: 'errorResponse-close',
      errorResponseShow: false,
      navCorrectFeedback: false, //是否开启纠错反馈  ("0".关闭，"1".开启)
      navCorrectUrl: '', //纠错反馈跳转链接
      activityUrl: '',
      checkedId: '', //门店列表选中的门店id
      isCheckedIcon: false, //是否选中地图图标门店
      isLoginFlag: false, // 默认没有登录
      mapHeight: 350,
      loginType: '', // 登录类型
      isStore: false,
      originLoginType: LoginType.None,
      isCorrectClient: true,
      channelTypeList: ['体验店', '专区专柜', '荣耀生活馆', '直营店', '授权店', '独立店'], // 门店类型集合
      isAMapFlag: true, //是否为高德地图 AMap
//       tempData:{
// 	"code": 200,
// 	"message": "操作成功",
// 	"result": [
// 		{
// 			"provinceName": "北京市",
// 			"citys": [
// 				{
// 					"cityName": "北京市",
// 					"quantity": "8308",
// 					"provinceName": "北京市"
// 				}
// 			]
// 		},
// 		{
// 			"provinceName": "广东省",
// 			"citys": [
// 				{
// 					"cityName": "",
// 					"quantity": "4",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "潮州市",
// 					"quantity": "231",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "东莞市",
// 					"quantity": "3792",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "佛山市",
// 					"quantity": "833",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "广州市",
// 					"quantity": "24868",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "河源市",
// 					"quantity": "146",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "惠州市",
// 					"quantity": "369",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "江门市",
// 					"quantity": "210",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "揭阳市",
// 					"quantity": "239",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "茂名市",
// 					"quantity": "207",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "梅州市",
// 					"quantity": "104",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "清远市",
// 					"quantity": "182",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "汕头市",
// 					"quantity": "112",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "汕尾市",
// 					"quantity": "93",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "韶关市",
// 					"quantity": "122",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "深圳市",
// 					"quantity": "15470",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "阳江市",
// 					"quantity": "276",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "云浮市",
// 					"quantity": "101",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "湛江市",
// 					"quantity": "277",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "肇庆市",
// 					"quantity": "190",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "中山市",
// 					"quantity": "288",
// 					"provinceName": "广东省"
// 				},
// 				{
// 					"cityName": "珠海市",
// 					"quantity": "489",
// 					"provinceName": "广东省"
// 				}
// 			]
// 		},
// 		{
// 			"provinceName": "重庆市",
// 			"citys": [
// 				{
// 					"cityName": "",
// 					"quantity": "4",
// 					"provinceName": "重庆市"
// 				},
// 				{
// 					"cityName": "重庆市",
// 					"quantity": "1615",
// 					"provinceName": "重庆市"
// 				}
// 			]
// 		}
// 	]
// }
    };
  },
  computed: {
    isCheckedId() {
      if (!this.isCheckedIcon || !this.checkedId) {
        return '';
      } else {
        return this.checkedId;
      }
    },
  },
  async created() {
    this.originLoginType = sessionStorage.getItem('originLoginType');
    this.isCorrectClient = checkClient(this.originLoginType);
    this.loginType = sessionStorage.getItem('loginType') || '';
    this.isLoginFlag = sessionStorage.getItem('isLoginFlag') === 'true' ? true : false;
    const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
    const query = this.$route.query;
    if (query) {
      const matchCode = (query.activityCode || '').match(/(HD\d{13})/);
      if (matchCode) {
        this.code = matchCode[0]; // 获取匹配的字符串
      } else {
        this.code = '';
      }
      
      // 邀请有礼携带参数
      this.shareRecordId = query.shareRecordId; // 邀请有礼分享id
      this.shareGiftFlag = query.shareGiftFlag; // 邀请有礼进入标识
      this.shareGiftCode = query.shareGiftCode; // 邀请有礼活动编码
    }

    // 组装当前地址
    this.activityUrl = location.origin + '/hd/hdmain?activityCode=' + this.code;
    if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
      this.activityUrl =
        this.activityUrl + '&ay=' + eventTrackingData.activityType + '&GUID=' + eventTrackingData.guideUserId + '&SC=' + eventTrackingData.storeCode;
    }
    const activityPictureUrl = sessionStorage.getItem('activityPictureUrl');
    if (activityPictureUrl) {
      this.bannerSrc = this.$utils.getImageUrl(activityPictureUrl);
    }

    try {
      this.isAMapFlag = await this.getMapType();
    } catch (error) {
      console.log('获取lookup配置失败', error);
      this.isAMapFlag = true;
    }
    this.initGeolocation();
    this.init();
  },
  methods: {
    init() {
      //初始化地图api
      this.getExtendConfig();
      this.initMap();
      this.getActivityDetail();
    },
    // 从localStorage读取extendConfig，进行变量的赋值
    getExtendConfig() {
      const extendConfig = this.$utils.getStorageItemObj('extendConfig');
      if (extendConfig && (extendConfig.sortCondition || extendConfig.filterCondition)) {
        this.screenTabShow = true;
        if (extendConfig.sortCondition) {
          this.sortConditionFlag = true;
          this.distanceCurrent = extendConfig.sortCondition == 'sortOpen_distanceSorting' ? 0 : 1;
          this.selectedDistanceSortType = extendConfig.sortCondition == 'sortOpen_distanceSorting' ? 'distanceSorting' : 'recommendationSorting';
          this.distanceSortCon = this.distanceCurrent == 0 ? '离我最近' : '推荐排序';
        }
        if (extendConfig.filterCondition) {
          this.filterConditionFlag = true;
          this.channelCurrent = 0;
          this.selectedChannelSortType = 'all';
          this.channelSortCon = '全部门店';
        }
      }
      if (extendConfig && (extendConfig.nextActivity || extendConfig.nextUrl)) {
        this.hasNextActivityFlag = true;
        this.nextActivityCode = extendConfig.nextActivity || extendConfig.nextUrl;
      }
      this.submitDocument = extendConfig && extendConfig.submitDocument ? extendConfig.submitDocument : '选门店';
      //设置小程序传过来的当前地理位置
      const locationInfo = JSON.parse(sessionStorage.getItem('locationInfo')) || {};
      const longitude = locationInfo.longitude || '';
      const latitude = locationInfo.latitude || '';
      const cityName = locationInfo.cityName || '';
      if (longitude && latitude && cityName) {
        this.position.lat = latitude;
        this.position.lng = longitude;
        this.position.city = cityName;
      } else {
        this.noLocationFlag = true;
      }
    },

    /**
     * 从lookup中读取配置的地图类型mapType
     */
    getMapType() {
      return new Promise((resolve, reject) => {
        this.$api.post({
          sc: 'mobileUser',
          url: 'lookUpManage/listPermissionTypeAndSys',
          params: { classifyCode: 'ihlp.mkt.channel.navigation.mapType' },
          success: (result) => {
            if (result.code == 200 && result.result && result.result[0]) {
              resolve(result.result[0].itemCode === '1' ? true : false);
            } else {
              resolve(true);
            }
          },
          fail: (error) => {
            reject(error);
          },
        });
      });
    },
    initGeolocation() {
      //获取定位api
      if (!this.isAMapFlag) {
        getGeolocation().then((geolocation) => {
          this.geolocation = geolocation;
          this.judgingEquipment();
        });
      }
    },
    //获取活动详情,如: 全部门店筛选类型，错误反馈标识等
    getActivityDetail() {
      let self = this;
      this.$api.post({
        sc: 'mobileMarketingH5',
        url: 'navigationActivity/getByActivityIdForH5?idOrCode=' + self.code,
        success: function (res) {
          if (res && res.result && res.result.activityPictureUrl) {
            self.navigateOtherSet = res.result.navigateOtherSet;
            self.bannerSrc = self.$utils.getImageUrl(res.result.activityPictureUrl);
            // 错误反馈标识，1表示开启了错误反馈
            self.navCorrectFeedback = res.result.navCorrectFeedback === '1' ? true : false;
            // 错误反馈跳转链接
            self.navCorrectUrl = res.result.navCorrectUrl || '';
          }
          // 提取全部门店类型
          if (res && res.result && res.result.storeNavigationChannelType) {
            const channelTypes = res.result.storeNavigationChannelType.split(',');
            const arr = [{ value: 'all', label: '全部门店' }];
            let obj = { value: '', label: '' };
            if (channelTypes.includes('0')) {
              obj = { value: '0', label: '体验店' };
              arr.push(obj);
            }
            if (channelTypes.includes('1')) {
              obj = { value: '1', label: '专区专柜' };
              arr.push(obj);
            }
            if (channelTypes.includes('2')) {
              obj = { value: '2', label: '荣耀生活馆' };
              arr.push(obj);
            }
            if (channelTypes.includes('3')) {
              obj = { value: '3', label: '直营店' };
              arr.push(obj);
            }
            if (channelTypes.includes('4')) {
              obj = { value: '4', label: '授权店' };
              arr.push(obj);
            }
            if (channelTypes.includes('5')) {
              obj = { value: '5', label: '独立店' };
              arr.push(obj);
            }
            self.channelSortArr = arr;
          }
        },
      });
    },
    getChannel(extendParams) {
      let self = this;
      self.isCheckedIcon = false;
      let params = {};
      let url = '';
      let sc = '';
      if (!this.shareGiftFlag) {
        // 场景1 一般场景进入（不从邀请有礼进入）
        params = {
          filter: {
            cityName: self.position.city,
            longitude: self.position.lng,
            dimension: self.position.lat,
            activityCode: self.code,
          },
          curPage: 1,
          pageSize: 10000,
        };
        url = 'navigationActivity/getChannelsByLongitudeDimension';
        const associationActivityCode = sessionStorage.getItem('associationActivityCode'); //编排活动code
        if (this.activityObj.isUsed == '1' && associationActivityCode) {
          // 活动编排的时候添加门店导航的组件调用这个接口
          url = 'navigationActivity/navigationActivityDetail';
          params.filter.associationActivityCode = associationActivityCode;
        }
        if (extendParams) {
          console.log('extendParams=======>', extendParams);
          params.filter.channelType = extendParams.channelType === 'all' ? '' : extendParams.channelType;
          params.filter.sortType = extendParams.sortType;
          if (extendParams.queryType != 'init' && self.position.city != self.selectedCity) {
            params.filter.cityName = self.selectedCity;
          }
        }
        sc = 'mobileMarketingH5';
      } else {
        // 场景2 邀请有礼活动详情点击“查看活动门店”
        params = {
          filter: {
            shareRecordId: self.shareRecordId,
            longitude: self.position.lng,
            dimension: self.position.lat,
            activityCode: self.shareGiftCode,
          },
          curPage: 1,
          pageSize: 10000,
        };
        url = 'miniActivityGiftStoreInviting/listJoinChannelForActivity';
        if (extendParams) {
          // 门店类别，0:体验店,1:专区专柜,2:生活体验馆,传空字符串则是全部门店
          params.filter.channelType = extendParams.channelType === 'all' ? '' : extendParams.channelType;
          //排序：0 距离优先、1 体验店优先
          params.filter.sortType = extendParams.sortType === 'recommendationSorting' ? '1' : '0';
          if (extendParams.queryType != 'init' && self.position.city != self.selectedCity) {
            params.filter.channelCityName = self.selectedCity;
            delete params.filter.longitude;
            delete params.filter.dimension;
          }
        }
        sc = 'mobileMarketing';
      }
      this.$api.post({
        sc: sc,
        url: url,
        params: params,
        success: function (r) {
          self.loadedFlag = true;
          if (r.code == 200 && r.result) {
            self.channelConut = r.result.length > 0 ? r.result[0].pagingMap.totalRows : 0;
            self.channelList = r.result;
            if (self.channelList.length > 0) {
              self.channelList[0].isRecent = true;
            }
            self.drawMarker(self.channelList);
          }
        },
        failure: function (r) {
          console.log(r);
        },
      });
    },
    //初始化地图
    initMap() {
      let self = this;
      if (!this.isAMapFlag) {
        //腾讯地图
        TMap().then((qq) => {
          let qqmaps = qq.maps;
          self.qqmaps = qqmaps;
          let center = (self.center = new qqmaps.LatLng(self.position.lat, self.position.lng));
          let map = new qqmaps.Map(self.$refs.mapContainer, {
            // 地图的中心地理坐标。
            center: center,
            zoom: 13,
            minZoom: 9,
            zoomControl: false, //不显示缩放
            mapTypeControlOptions: {
              //设置控件的地图类型为普通街道地图
              mapTypeIds: qqmaps.MapTypeId.ROADMAP,
            },
          });
          self.mapEntity = map;
          self.drawMarker(self.channelList);
          self.addSearchBtn();
        });
      } else {
        //高德地图
        AMapLoaderNew().then((AMap) => {
          const map = new AMap.Map(this.$refs.mapContainer, {
            center: [this.position.lng, this.position.lat],
            resizeEnable: true,
            zoom: 13,
            lang: 'zh',
          });

          this.AMap = AMap;
          this.map = map;
          // 异步加载插件：AMap.Geolocation：
          // 插件功能：定位，提供了获取用户当前准确位置、所在城市的方法
          map.plugin('AMap.Geolocation', () => {
            const geolocation = new AMap.Geolocation({
              enableHighAccuracy: true, //是否使用高精度定位，默认:true
              timeout: 50000, //超过10秒后停止定位，默认：无穷大
              maximumAge: 0, //定位结果缓存0毫秒，默认：0
              convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
              showButton: true, //显示定位按钮，默认：true
              buttonPosition: 'LB', //定位按钮停靠位置，默认：'LB'，左下角
              buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
              showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
              showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
              panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
              zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
              needAddress: true, //是否需要将定位结果进行逆地理编码操作
            });
            this.geolocation = geolocation;
            if (this.noLocationFlag) {
              // 默认地理位置则拉起定位
              this.getCurrentPosition();
            } else {
              this.showPosition(this.position);
            }
          });

          this.mapEntity = map;
          this.drawMarker(this.channelList);
          this.addSearchBtn();
        });
      }
    },

    //根据设备类型,选择不同的定位方法进行定位
    judgingEquipment() {
      const versions = this.$browser.versions;
      const extendConfig = this.$utils.getStorageItemObj('extendConfig');
      if (this.geolocationErrorCode === 1) {
        return false;
      }
      if (versions.mobile) {
        if (extendConfig && extendConfig.getUserLocation != false) {
          if (!this.isAMapFlag) {
            // 立即获取当前所在地理位置，适用于非精确定位场景，是IP定位，城市级别
            this.geolocation.getLocation(this.showPosition, this.showErr, {
              timeout: 9000,
              failTipFlag: true,
            });
          } else {
            this.getCurrentPosition();
          }
        } else {
          this.showErr({ code: 1 });
          this.geolocationErrorCode = 1;
          this.getUserLocationFlag = false;
        }
      } else {
        //否则就是PC浏览器打开
        if (extendConfig && extendConfig.getUserLocation != false) {
          if (!this.isAMapFlag) {
            this.geolocation.getIpLocation(this.showPosition, this.showErr);
          } else {
            this.geolocation.getCityInfo((status, result) => {
              if (status === 'complete') {
                this.showPosition(result);
              } else if (status === 'error') {
                this.showErr(result);
              }
            });
          }
        } else {
          this.showErr({ code: 1 });
          this.geolocationErrorCode = 1;
          this.getUserLocationFlag = false;
        }
      }
    },
    // 获取当前位置
    async getCurrentPosition() {
      const env = getEnvMark();
      if (env === EnvMark.alipayMp && /(Android)/i.test(navigator.userAgent)) {
        const position = {};
        // 在安卓机在支付宝小程序环境打开，由于高德JS API定位有偏移，因此使用浏览器原生定位方法
        const positionObj = await getLocationInfoByGeolocation(true);
        if (positionObj.status === 'complete') {
          // 转换坐标系（WSG84 -> GCJ02）
          AMapLoaderNew().then((AMap) => {
            AMap.convertFrom([positionObj.longitude, positionObj.latitude], 'gps', (status, result) => {
              if (result.info === 'ok') {
                const lngLats = result.locations[0];
                // 逆地理编码（坐标 -> 地址）
                //加载地理编码插件
                this.map.plugin(['AMap.Geocoder'], () => {
                  //加载地理编码插件
                  const geoCoder = new AMap.Geocoder({
                    radius: 1000, //以已知坐标为中心点，radius为半径，返回范围内兴趣点和道路信息
                    extensions: 'all', //返回地址描述以及附近兴趣点和道路信息，默认“base”
                  });
                  //逆地理编码
                  geoCoder.getAddress(new AMap.LngLat(lngLats.lng, lngLats.lat), (status, result) => {
                    if (status === 'complete') {
                      position.addressComponent = result.regeocode.addressComponent;
                      position.longitude = lngLats.lng;
                      position.latitude = lngLats.lat;
                      position.position = {
                        lng: lngLats.lng,
                        lat: lngLats.lat,
                      };
                      this.noLocationFlag = false;
                      this.showPosition(position);
                    } else {
                      console.error('逆地理编码解析失败', status, result);
                      this.noLocationFlag = true;
                      this.showErr(position);
                    }
                  });
                });
              } else {
                console.error('坐标系转换失败', status, result);
                this.noLocationFlag = true;
                this.showErr(position);
              }
            });
          });
        } else {
          console.error('使用原生浏览器定位方法失败');
          this.noLocationFlag = true;
          this.showErr(position);
        }
      } else {
        this.geolocation.getCurrentPosition((status, result) => {
          if (status === 'complete') {
            this.noLocationFlag = false;
            this.showPosition(result);
          } else if (status === 'error') {
            this.showErr(result);
          }
        });
      }
    },
    //启动定时获取定位信息，持续2次后结束
    myGetLocation() {
      let self = this;
      self.getLocationCount = 0;
      clearInterval(self.myInterval);
      self.myInterval = setInterval(function () {
        self.getLocationCount++;
        self.judgingEquipment();
        if (self.getLocationCount > 2) {
          clearInterval(self.myInterval);
        }
      }, 2500);
    },
    showPosition(position) {
      console.log('position');
      console.log(position);
      let showMyPosition = true;
      let city = '北京市';
      // 高德地图
      if (this.isAMapFlag && position.position) {
        if (position.addressComponent) {
          city = position.addressComponent.city || position.addressComponent.province;
          position.city = city;
          position = position.position;
        } else {
          const position2 = {};
          position2.city = '北京市';
          this.selectedCity = '北京市';
          position2.lng = 116.397128;
          position2.lat = 39.916527;
          this.showGPS = false;
          position = position2;
          showMyPosition = false; //默认北京市不展示当前位置图标
        }
        position.city = city;
        // 同时设置地图中心点和缩放级别
        this.map.setZoomAndCenter(13, [position.lng, position.lat]);
      }
      const p = this.position;
      p.index++;
      if (this.getLocationCount === 0 && !this.noLocationFlag && !this.isAMapFlag) {
        this.myGetLocation();
      }
      //如果位置有变化，则更新位置和中心点
      if (p.lat != position.lat || p.lng != position.lng || this.isMastInit || this.$utils.isEmptyObject(this.myMarker)) {
        //缓存位置数据
        this.$utils.setStorageItemObj('cachePosition', position);
        this.isMastInit = false;
        //赋值坐标
        this.$utils.getFormAttrValue(this.position, position);
        this.locationCity = position.city || '无法获取当前位置';
        if (!this.noLocationFlag && showMyPosition) {
          this.$utils.isEmptyObject(this.myMarker) ? '' : this.map.remove(this.myMarker); // 清除标记点marker
          this.mySetCenter();
        }
        this.selectedCity = position.city;
        this.locateSuccessFlag = true;

        //坐标变了要重新查询最近门店
        if (this.selectedDistanceSortType || this.selectedChannelSortType) {
          const extendParams = {
            channelType: this.selectedChannelSortType,
            sortType: this.selectedDistanceSortType,
            queryType: 'init',
          };
          this.getChannel(extendParams);
        } else {
          this.getChannel();
        }
      }
    },
    //获取定位异常后，重置定位到北京
    showErr(error) {
      let self = this;
      console.log(JSON.stringify(error));
      this.geolocationErrorCode = error && error.code;
      if (error.code != '1') {
        if (self.getLocationCount === 0) {
          self.myGetLocation(true);
          return false;
        } else if (self.getLocationCount == 2) {
          self.noLocationFlag = true;
          let position = {};
          position.city = '北京市';
          self.selectedCity = '北京市';
          position.lng = 116.397128;
          position.lat = 39.916527;
          this.showPosition(position);
          this.showGPS = false;
        }
      } else {
        self.noLocationFlag = true;
        let position = {};
        position.city = '北京市';
        self.selectedCity = '北京市';
        position.lng = 116.397128;
        position.lat = 39.916527;
        this.showPosition(position);
        this.showGPS = false;
      }
    },
    //设置地图中心点，和我的位置点
    mySetCenter() {
      const self = this;
      if (!this.isAMapFlag) {
        let qqmaps = this.qqmaps,
          center = new qqmaps.LatLng(self.position.lat, self.position.lng);
        self.mapEntity.setCenter(center);
        if (self.$utils.isEmptyObject(self.myMarker)) {
          //创建地图上的点为我的位置
          let marker = new qq.maps.Marker({
            position: center,
            map: self.mapEntity,
            animation: qqmaps.MarkerAnimation.DROP,
          });
          this.myMarker = marker;
          let anchor = new qqmaps.Point(15, 44),
            size = new qqmaps.Size(18, 22),
            origin = new qqmaps.Point(0, 0),
            scaleSize = new qqmaps.Size(18, 22),
            //替换图标
            markerIcon = new qq.maps.MarkerImage(
              'static/runtime/images/magic/location.png',
              size,
              origin,
              anchor, //会引起缩放时位置变化过大
              scaleSize
            );
          marker.setIcon(markerIcon);
          marker.setZIndex(99);
        } else {
          self.myMarker.setPosition(center);
        }
      } else {
        const AMap = this.AMap;
        const icon = new AMap.Icon({
          size: new AMap.Size(18, 22), // 图标尺寸
          image: 'static/runtime/images/magic/location.png',
          imageSize: new AMap.Size(18, 22), // 根据所设置的大小拉伸或压缩图片
        });

        // 将 Icon 实例添加到 marker 上:
        const marker = new AMap.Marker({
          position: new AMap.LngLat(self.position.lng, self.position.lat),
          icon: icon,
          zoom: 13,
        });

        // 将创建的点标记添加到已有的地图实例：
        this.map.add(marker);
        this.myMarker = marker;
      }
    },
    //重新获取我的定位
    restMyGetLocation() {
      this.isMastInit = true;
      this.judgingEquipment();
      if (!this.isAMapFlag) {
        this.mapEntity.setZoom(15);
      }
    },
    //添加门店位置图标，点击事件
    drawMarker(data) {
      let self = this;
      this.showShopMsg = false;
      self.$refs.toLocation.style.bottom = '72px';
      self.$refs.minimize.style.bottom = '72px';
      self.$refs.maximize.style.bottom = '50px';
      self.$refs.maximize.style.right = '10px';
      if (!self.$utils.isEmptyObject(self.mapEntity)) {
        // let mWidth=this.$pScreen.mainP*30
        // let mHeight=this.$pScreen.mainP*44

        if (!this.isAMapFlag) {
          for (let i in this.mapMakers) {
            this.mapMakers[i].setMap(null);
          }
          this.mapMakers.length = 0;

          let anchor = new qq.maps.Point(15, 44),
            size = new qq.maps.Size(18, 22),
            origin = new qq.maps.Point(0, 0),
            scaleSize = new qq.maps.Size(18, 22),
            markerIcon = new qq.maps.MarkerImage('static/runtime/images/magic/shopNew.png', size, origin, anchor, scaleSize);

          for (let i = 0; i < data.length; i++) {
            let item = data[i];
            console.log('添加门店位置图标，点击事件', item);
            let marker = new qq.maps.Marker({
              position: new qq.maps.LatLng(item.gcj02Latitude, item.gcj02Longitude),
              map: self.mapEntity,
            });
            this.mapMakers.push(marker);
            marker.name = item.channelName;
            marker.distance = item.distance;
            marker.phone = item.sensitizationMobilephone || item.telephone;
            marker.address = item.channelAddress;
            marker.channelType = item.channelType;
            //添加地图门店点标识
            marker.channelId = item.id;
            //以id缓存门店信息
            self.channelCache[item.id] = item;
            self.markerCache[item.id] = marker;

            marker.setIcon(markerIcon);
            //给地图上门店的点添加点击事件
            qq.maps.event.addListener(marker, 'click', function (e) {
              self.setChannelSeMarker(marker, e.target.channelId);
              self.isCheckedIcon = true;
            });
          }
          qq.maps.event.addListener(self.mapEntity, 'click', function () {
            if (!self.$utils.isEmptyObject(self.seMarker)) {
              self.seMarker.setIcon(markerIcon);
              self.seChannel = { channelAddress: '', channelName: '' };
              self.seMarker = {};
              self.showShopMsg = false;
            }
            self.$refs.toLocation.style.bottom = '72px';
            self.$refs.minimize.style.bottom = '72px';
            self.$refs.maximize.style.bottom = '50px';
            self.$refs.maximize.style.right = '10px';
            self.isCheckedIcon = false;
          });
        } else {
          this.map.remove(this.mapMakers);
          this.mapMakers = [];
          let AMap = this.AMap;
          let markerIcon = new AMap.Icon({
            size: new AMap.Size(18, 22), // 图标尺寸
            image: 'static/runtime/images/magic/shopNew.png',
            imageSize: new AMap.Size(18, 22), // 根据所设置的大小拉伸或压缩图片
          });

          for (let i = 0; i < data.length; i++) {
            let item = data[i];
            // 将 Icon 实例添加到 marker 上:
            let marker = new AMap.Marker({
              position: new AMap.LngLat(item.gcj02Longitude, item.gcj02Latitude),
              icon: markerIcon,
            });
            this.mapMakers.push(marker);
            // 将创建的点标记添加到已有的地图实例：
            this.map.add(marker);
            marker.name = item.channelName;
            marker.distance = item.distance;
            marker.phone = item.sensitizationMobilephone || item.telephone;
            marker.address = item.channelAddress;
            marker.channelType = item.channelType;
            marker.channelId = item.id;
            //以id缓存门店信息
            this.channelCache[item.id] = item;
            this.markerCache[item.id] = marker;
            marker.on('click', (e) => {
              this.setChannelSeMarker(marker, e.target.channelId);
            });
            this.mapEntity.on('click', function () {
              if (!self.$utils.isEmptyObject(self.seMarker)) {
                self.seMarker.setIcon(markerIcon);
                self.seChannel = { channelAddress: '', channelName: '' };
                self.seMarker = {};
                self.showShopMsg = false;
                self.isCheckedIcon = false;
              }
              self.$refs.toLocation.style.bottom = '72px';
              self.$refs.minimize.style.bottom = '72px';
              self.$refs.maximize.style.bottom = '50px';
              self.$refs.maximize.style.right = '10px';
            });
          }
        }
      }
    },
    setChannelSeMarker(marker, channelId) {
      let self = this;
      if (!this.isAMapFlag) {
        let anchor = new qq.maps.Point(15, 44),
          size = new qq.maps.Size(18, 22),
          selectedSize = new qq.maps.Size(22, 26),
          selectedScaleSize = new qq.maps.Size(22, 26),
          origin = new qq.maps.Point(0, 0),
          scaleSize = new qq.maps.Size(18, 22),
          markerIcon = new qq.maps.MarkerImage('static/runtime/images/magic/shopNew.png', size, origin, anchor, scaleSize),
          markerIconSelected = new qq.maps.MarkerImage('static/runtime/images/magic/shopSelectedNew.png', selectedSize, origin, anchor, selectedScaleSize);

        this.isCheckedIcon = true;
        self.seChannel = self.channelCache[channelId];
        self.checkedId = channelId;
        if (!self.$utils.isEmptyObject(self.seMarker)) {
          self.seMarker.setIcon(markerIcon);
          marker.setZIndex(0);
        }

        marker.setIcon(markerIconSelected);
        marker.setZIndex(80);
        self.seMarker = marker;
        self.showShopMsg = true;
        self.$refs.toLocation.style.bottom = '154px';
        self.$refs.minimize.style.bottom = '154px';
        // self.$refs.maximize.style.right = "160px";
        self.$refs.maximize.style.right = '11160px';
      } else {
        let AMap = this.AMap;
        let markerIcon = new AMap.Icon({
          size: new AMap.Size(18, 22), // 图标尺寸
          image: 'static/runtime/images/magic/shopNew.png',
          imageSize: new AMap.Size(18, 22), // 根据所设置的大小拉伸或压缩图片
        });
        let markerIconSelected = new AMap.Icon({
          size: new AMap.Size(22, 26),
          image: 'static/runtime/images/magic/shopSelectedNew.png',
          imageSize: new AMap.Size(22, 26),
        });
        this.isCheckedIcon = true;
        this.checkedId = channelId;
        this.seChannel = this.channelCache[channelId];
        if (!this.$utils.isEmptyObject(this.seMarker)) {
          this.seMarker.setIcon(markerIcon);
        }
        marker.setIcon(markerIconSelected);
        this.seMarker = marker;
        this.showShopMsg = true;
        this.$refs.toLocation.style.bottom = '154px';
        this.$refs.minimize.style.bottom = '154px';
        this.$refs.maximize.style.right = '11160px';
      }
    },
    //添加搜索按钮
    addSearchBtn() {
      //创建div元素
      const customZoomDiv = this.$refs.searchBtn;
      //将控件添加到controls栈变量并将其设置在顶部位置
      if (!this.isAMapFlag) {
        this.mapEntity.controls[qq.maps.ALIGN.TOP_LEFT].push(customZoomDiv);
      }
    },
    //切换省份
    changeProvince(key) {
      this.provinceSortNum = key;
      this.citySortNum = key;
      this.dealHeight()
    },
    //点击GPS城市，重新定位
    selectGPSCity() {
      this.isMastInit = true;
      this.judgingEquipment();
      this.searchContainerShowFlag = false;
    },
    //选择城市
    selectCity(item, key) {
      if (!this.getUserLocationFlag) {
        this.locationCity = item.cityName;
      }
      let self = this;
      self.isCheckedIcon = false;
      let cityName = item.cityName.slice(0, item.cityName.length - 1);
      let params = {};
      let url = '';
      let sc = 'marketing';
      if (!this.shareGiftFlag) {
        // 场景1 一般场景进入（不从邀请有礼进入）
        params = {
          filter: {
            cityName: cityName,
            channelName: '',
            longitude: self.position.lng,
            dimension: self.position.lat,
            activityCode: self.code,
            channelType: self.selectedChannelSortType === 'all' ? '' : self.selectedChannelSortType,
            sortType: self.selectedDistanceSortType,
          },
          curPage: 1,
          pageSize: 10000,
        };
        url = 'navigationActivity/getChannelsByLongitudeDimension';
        if (this.activityObj.isUsed == '1' && sessionStorage.getItem('associationActivityCode')) {
          url = 'navigationActivity/navigationActivityDetail';
          params.filter.associationActivityCode = sessionStorage.getItem('associationActivityCode');
        }
        sc = 'mobileMarketingH5';
      } else {
        // 场景2 邀请有礼活动详情点击“查看活动门店”
        // sortType 排序：0距离优先、1体验店优先
        // channelType 门店类别，0:体验店,1:专区专柜,2:生活体验馆 传空字符传则为全部类型
        params = {
          filter: {
            channelCityName: cityName,
            channelName: '',
            longitude: self.position.lng,
            dimension: self.position.lat,
            activityCode: self.shareGiftCode,
            channelType: self.selectedChannelSortType === 'all' ? '' : self.selectedChannelSortType,
            sortType: self.selectedDistanceSortType === 'recommendationSorting' ? '1' : '0',
          },
          curPage: 1,
          pageSize: 10000,
        };
        url = 'miniActivityGiftStoreInviting/listJoinChannelForActivity';
        sc = 'mobileMarketing';
      }

      this.$api.post({
        sc: sc,
        url: url,
        params: params,
        success: function (r) {
          self.cityNameList.push(cityName);
          if (r.code == 200 && r.result) {
            let result = r.result;
            self.channelList = result;
            self.channelList[0].isRecent = true;
            self.selectedCity = item.cityName;
            self.channelConut = result[0].pagingMap.totalRows;
            self.drawMarker(self.channelList);
            self.cityCahnnelCache[cityName] = result[0];
            console.log('选择城市', result[0]);
            if (!self.isAMapFlag) {
              self.mapEntity.panTo(new qq.maps.LatLng(result[0].gcj02Latitude, result[0].gcj02Longitude));
            } else {
              self.map.setZoomAndCenter(13, [result[0].gcj02Longitude, result[0].gcj02Latitude]);
            }
          }
        },
        failure: function (r) {
          console.log(r);
        },
      });
      this.searchContainerShowFlag = false;
    },
    //切换省市列表显示或隐藏
    toggleCity() {
      this.areaWrapperShowFlag = !this.areaWrapperShowFlag;
    },
    //隐藏大地图的门店数量
    deleteTips() {
      this.shopTipsShowFlag = false;
    },
    //打开搜索框
    openSearchContainer() {
      let self = this;
      // self.cityData = self.tempData.result
      // self.dealHeight()
      if (self.cityData.length == 0) {
        this.$api.get({
          sc: 'mobileMarketingH5',
          url: 'navigationActivity/getChannelQuantity/' + self.code,
          success: function (r) {
            console.log(r);
            if (r.code === 200 && r.result) {
              self.cityData = r.result;
              self.dealHeight()
            }
          },
          failure: function (r) {
            console.log(r);
          },
        });
      }
      this.searchContainerShowFlag = true;
      this.areaWrapperShowFlag = true;
    },
    //点击空白区域隐藏
    hidePanel(event) {
      let searchContent = this.$refs.searchContent;
      if (!searchContent.contains(event.target)) {
        this.searchContainerShowFlag = false;
      }
    },
    //搜索框输入
    ipt(e) {
      if (e.target.value == '') {
        this.searchBtnShowFlag = false;
      } else {
        this.searchBtnShowFlag = true;
      }
    },
    //搜索框获取焦点
    inptFocus() {
      this.areaWrapperShowFlag = false;
    },
    //清除搜索框数据
    clearIpt() {
      this.iptVal = '';
      this.searchBtnShowFlag = false;
    },
    //关闭搜索框
    close() {
      this.searchContainerShowFlag = false;
    },
    //搜索跳转页面
    search() {
      this.search2();
      this.searchContainerShowFlag = false;
      this.searchResultShowFlag = true;
      this.channelShowFlag = false;
    },
    //第二个搜索
    search2() {
      let self = this;
      self.isCheckedIcon = false;
      let params = {
        filter: {
          cityName: '',
          channelName: self.iptVal,
          longitude: '',
          dimension: '',
          activityCode: self.code,
        },
        curPage: 1,
        pageSize: 10000,
      };
      let sc = '';
      let url = '';
      if (!this.shareGiftFlag) {
        // 场景1 一般场景进入（不从邀请有礼进入）
        url = 'navigationActivity/getChannelsByLongitudeDimension';
        if (this.activityObj.isUsed == '1' && sessionStorage.getItem('associationActivityCode')) {
          url = 'navigationActivity/navigationActivityDetail';
          params.filter.associationActivityCode = sessionStorage.getItem('associationActivityCode');
        }
        sc = 'mobileMarketingH5';
      } else {
        // 场景2 邀请有礼活动详情点击“查看活动门店”
        params.filter.activityCode = self.shareGiftCode;
        url = 'miniActivityGiftStoreInviting/listJoinChannelForActivity';
        sc = 'mobileMarketing';
      }
      this.$api.post({
        sc: sc,
        url: url,
        params: params,
        success: function (r) {
          self.searchChannelList = r.result;
        },
        failure: function (r) {},
      });
    },
    //地图最大化
    maximize() {
      this.mapHeight = this.$pScreen.height;
      this.channelShowFlag = false;
      this.loationShowFlag = false;
      this.maximizeShowFlag = false;
      this.shopTipsShowFlag = true;
      this.toLocationShowFlag = true;
      this.minimizeShowFlag = true;
      this.bannerShowFlag = false;
    },
    //地图最小化
    minimize() {
      this.mapHeight = 350;
      this.channelShowFlag = true;
      this.loationShowFlag = true;
      this.maximizeShowFlag = true;
      this.shopTipsShowFlag = false;
      this.toLocationShowFlag = false;
      this.minimizeShowFlag = false;
      this.bannerShowFlag = true;
    },
    goback() {
      this.searchResultShowFlag = false;
      this.channelShowFlag = true;
    },
    //点击地址跳转到腾讯地图
    openMap(item) {
      //先判断是否开启了跳转导航
      if (this.navigateOtherSet == '0') {
        return false;
      }
      console.log('门店导航搜索门店点击跳转地图', item);
      jumpToMapNavigation(item, this.loginType);
    },
    //点击门店名称，地图上切换中心点到该门店
    toChannelPosition(item, e) {
      const className = e.target.className;
      this.checkedId = item.id;
      this.isCheckedIcon = true;
      console.log('点击门店名称切换中心点到该门店', item);
      if (className.indexOf('additionalArea') == -1) {
        const seMarker = this.markerCache[item.id];
        this.setChannelSeMarker(seMarker, item.id);
        if (!this.isAMapFlag) {
          this.mapEntity.panTo(new qq.maps.LatLng(item.gcj02Latitude, item.gcj02Longitude));
        } else {
          this.map.setZoomAndCenter(13, [item.gcj02Longitude, item.gcj02Latitude]);
        }
      }
    },
    //保存
    save() {
      let self = this;
      let pse = this.$refs.baseForm.getFormData('formCustom');
      pse.then(
        function (formCustom) {
          self.$api.post(
            'fundAccount/addFundAccount',
            formCustom,
            (r) => {
              self.$utils.tips.aSuccess;
              //刷新list页面列表
              self.$emit('handleSubmit', 'formCustom');
              self.handleClose();
            },
            null,
            'finance'
          );
        },
        (reject) => {}
      );
    },
    //距离筛选
    distanceChange() {
      this.isStore = false;
      this.distanceContentShow = !this.distanceContentShow;
      this.channelContentShow = false;
    },
    //门店筛选
    channelChange() {
      this.channelContentShow = !this.channelContentShow;
      this.distanceContentShow = false;
      this.isStore = true;
    },
    //选择距离条件筛选
    chooseDistanceType(item, index) {
      this.distanceCurrent = index;
      this.distanceContentShow = false;
      this.selectedDistanceSortType = item.value;
      this.distanceSortCon = item.label;
      let params = {
        sortType: this.selectedDistanceSortType,
        channelType: this.selectedChannelSortType,
      };
      this.getChannel(params);
    },
    //选择门店条件筛选
    chooseChannelType(item, index) {
      this.channelCurrent = index;
      this.channelContentShow = false;
      this.selectedChannelSortType = item.value;
      this.channelSortCon = item.label;
      let params = {
        sortType: this.selectedDistanceSortType,
        channelType: this.selectedChannelSortType,
      };
      this.getChannel(params);
    },
    //点击空白区域隐藏遮罩层
    hideSomething(e) {
      if (e.target.className != 'customSelect' && e.target.className != 'sortItem current' && e.target.className != 'conidtionWrapper') {
        this.distanceContentShow = false;
        this.channelContentShow = false;
      }
    },
    //进入下一级活动
    toNextActivity(item) {
      // 登入方式为微信登入，且当前没有登入时
      if (!this.isLoginFlag && (this.loginType === 'wechat' || this.loginType === 'Alipay')) {
        noLoginHandler(this.loginType, this.activityUrl);
        return;
      }
      if (this.isDisabled) {
        return false;
      }
      this.isDisabled = true;
      const self = this;
      // 父级页面信息
      const parentPageParams = {
        activityCode: '',
        parentPage: 'storeNavigation',
        parentActivityCode: this.code,
      };
      sessionStorage.setItem('navChannelCode', item.channelCode);
      // 不存在associationActivityCode => 非活动编排
      if (!sessionStorage.getItem('associationActivityCode')) {
        // 下级活动链接中，值为活动编码时(下级组件)
        if (self.nextActivityCode.indexOf('http') == -1 && self.nextActivityCode.indexOf('https') == -1 && self.nextActivityCode.indexOf('HD') > -1) {
          parentPageParams.activityCode = self.nextActivityCode;
          const path = utils.appendParamsToURL(parentPageParams);
          self.$router.push({
            path: path,
          });
          // 通过重新渲染router-view，来刷新路由（由于是同一路由之间的跳转，所以需要手动刷新）
          self.$store.commit('base/setIsRouterAlive', false);
          self.$nextTick(() => self.$store.commit('base/setIsRouterAlive', true));
        } else {
          const currentOrigin = window.location.origin;
          // 下级活动链接跳转的域名和当前的域名一致，且下级活动为活力魔方内的活动（活动链接）
          if (self.nextActivityCode.indexOf(currentOrigin) > -1 && self.nextActivityCode.indexOf('hdmain') > -1) {
            parentPageParams.activityCode = self.nextActivityCode.split('activityCode=')[1];
            const path = utils.appendParamsToURL(parentPageParams);
            self.$router.push({
              path: path,
            });
            self.$store.commit('base/setIsRouterAlive', false);
            self.$nextTick(() => self.$store.commit('base/setIsRouterAlive', true));
          } else {
            window.location.href = self.nextActivityCode;
          }
        }
        return false;
      }
      let userBase = self.$store.state.userInfo.userBase;
      let userInfo = sessionStorage.getItem('userInfo');
      if (userInfo) {
        userInfo = JSON.parse(userInfo);
        userBase = Object.assign(userBase, userInfo);
      }
      let userGender = '';
      if (userBase.sex == 1 || userBase.gender == 'm') {
        userGender = '1';
      } else if (userBase.sex == 2 || userBase.gender == 'f') {
        userGender = '2';
      }
      const params = {
        userOpenid: userBase.openId || '',
        userUnionid: userBase.unionid || '',
        userGender: userGender,
        nickName: userBase.nickName || '',
        alipayUserId: sessionStorage.getItem('alipayUserId') || '',
        activityCode: item.activityCode,
        activityChannelId: item.id,
        loginType: sessionStorage.getItem('loginType'),
        associationActivityCode: sessionStorage.getItem('associationActivityCode'),
      };
      let crtlParams = sessionStorage.getItem('crtlParams');
      if (crtlParams) {
        crtlParams = JSON.parse(crtlParams);
        params.loginType = crtlParams.loginType;
        params.answerTimes = 'once';
      }
      if (sessionStorage.getItem('connectionId')) {
        // params.userUnionid = sessionStorage.getItem("connectionId");
        params.connectionId = sessionStorage.getItem('connectionId');
      }
      if (!sessionStorage.getItem('alipayUserId')) {
        // 支付宝已经是隐私结构体了
        const privacyKeys = {
          nickName: '$PrivacyPlain$',
        };
        //隐私信息保存
        const privacyKeyLsit = [
          {
            nickName: 'nickName',
            typeText: 'NAME',
            labelText: 'mktMagicShareCpsNickName',
          },
        ];
        self.$utils.privacySave(privacyKeys, privacyKeyLsit, params);
      }

      self.$api.post({
        sc: 'mobileMarketingH5',
        url: 'navigationActivity/editNavigationActivity',
        params: params,
        success: (r) => {
          if (r.result) {
            sessionStorage.setItem('connectionId', r.result);
          }
          if (self.nextActivityCode.indexOf('http') == -1 && self.nextActivityCode.indexOf('https') == -1 && self.nextActivityCode.indexOf('HD') > -1) {
            parentPageParams.activityCode = self.nextActivityCode;
            const path = utils.appendParamsToURL(parentPageParams);
            self.$router.push({
              path: path,
            });
            self.$store.commit('base/setIsRouterAlive', false);
            self.$nextTick(() => self.$store.commit('base/setIsRouterAlive', true));
          } else {
            const currentOrigin = window.location.origin;
            if (self.nextActivityCode.indexOf(currentOrigin) > -1 && self.nextActivityCode.indexOf('hdmain') > -1) {
              parentPageParams.activityCode = self.nextActivityCode.split('activityCode=')[1];
              const path = utils.appendParamsToURL(parentPageParams);
              self.$router.push({
                path: path,
              });
              self.$store.commit('base/setIsRouterAlive', false);
              self.$nextTick(() => self.$store.commit('base/setIsRouterAlive', true));
            } else {
              window.location.href = self.nextActivityCode;
            }
          }
        },
        failure: () => {
          self.isDisabled = false;
          Dialog.alert({
            title: title || '提示',
            message: '活动过于火爆，请稍后再试',
          });
        },
      });
    },

    //关闭
    handleClose() {
      let tabItemName = this.$parent.name;
      this.$emit('handleClose', tabItemName);
    },

    //纠错反馈点击事件
    handleErrorResponse(navUrl) {
      if (!this.isLoginFlag && (this.loginType === 'wechat' || this.loginType === 'Alipay')) {
        this.$utils.tips.message('warning', '请先登录，再反馈');
        return;
      }
      //点击遮罩层只执行关闭逻辑
      if (navUrl) {
        this.errorResponseClass = 'errorResponse-close';
        this.errorResponseShow = false;
        return;
      }
      //展开后点击执行页面跳转逻辑
      if (this.errorResponseClass === 'errorResponse-open') {
        const currentOrigin = window.location.origin;
        // 父级页面信息
        const parentPageParams = {
          activityCode: '',
          parentPage: 'storeNavigation',
          parentActivityCode: this.code,
        };
        const link = this.navCorrectUrl;
        if (link.indexOf(currentOrigin) > -1 && link.indexOf('hdmain') > -1) {
          // 支持http链接形式：https://hd-sit1.test.hihonor.com/hd/hdmain?activityCode=HD1683368408620
          // 也支持小程序链接形式如：pages/webView/activity-web-view?webViewSrc=https://hd-sit1.test.hihonor.com/hd/hdmain?activityCode=HD1683368408620
          // const path = '/hdmain?' + link.split('?')[1] + loginParams;
          parentPageParams.activityCode = link.split('activityCode=')[1];
          const path = utils.appendParamsToURL(parentPageParams);
          this.$router.push({
            path: path,
          });
          this.$store.commit('base/setIsRouterAlive', false);
          this.$nextTick(() => this.$store.commit('base/setIsRouterAlive', true));
        } else {
          window.location.href = link;
        }
      }
      this.errorResponseClass = this.errorResponseClass === 'errorResponse-open' ? 'errorResponse-close' : 'errorResponse-open';
      this.errorResponseShow = !this.errorResponseShow;
    },

    // 处理省市列表高度

    dealHeight(){
      const provinceListLength = this.cityData.length
      const cityListLength = this.cityData[this.provinceSortNum].citys.length
      console.log('00000',provinceListLength,cityListLength)
      if(provinceListLength < 3 || provinceListLength === 3){
        if(cityListLength < 3 || cityListLength === 3){
          this.provinceListAndCityListHeight = 120; // 3个高度
          console.log('11111')
        }else if(cityListLength > 3 && (cityListLength < 8 || cityListLength === 8)){
          this.provinceListAndCityListHeight = cityListLength*40
          console.log('2222222')
        }else{
          this.provinceListAndCityListHeight = 340
          console.log('33333')
        }
      }else if(provinceListLength > 3 && (provinceListLength < 8 || provinceListLength === 8)){
        if(cityListLength < 8 || cityListLength === 8){
          this.provinceListAndCityListHeight = provinceListLength > cityListLength ?  provinceListLength*40:cityListLength*40
          console.log('444444')
        }else{
          this.provinceListAndCityListHeight = 340
          console.log('5555555')
        }
      }else{
        this.provinceListAndCityListHeight = 340
        console.log('666666')
      }
    }
  },
};
</script>
<style scoped>
.navigation-main .map-container {
  width: 750px;
}
@media (min-width: 750px) {
  .fixedMap {
    left: calc(50% - 375px) !important;
  }
}
.top_home .main {
  page-break-before: always;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
}

ul,
li {
  list-style: none;
}
.storeList {
  background-color: #f2f3f9;
}
.mainPageContainer {
  padding: 10px 0;
}
.bgcWall {
  width: 100%;
  background-color: #f2f3f9;
  position: absolute;
  top: 40px;
  height: calc(24vw - 40px);
}
.shopItem {
  padding: 18px 10px 12px 15px;
  line-height: 30px;
  box-sizing: border-box;
  margin: 0 15px 10px;
  border-radius: 10px;
  position: relative;
  border: 2px solid #fff !important;
}
.shopItemMax {
  padding: 12px 0;
  margin: 10px 15px;
  position: relative;
}

.store-name {
  color: #000000;
  font-weight: 600;
  font-size: 16px;
}
.shortTag {
  text-align: center;
  width: 50px;
  background: #ffeeee;
  height: 14px;
  font-size: 10px;
  line-height: 14px;
  color: #f93d41;
  margin: 0 auto;
  position: absolute;
  right: 0px;
  top: 0px;
  border-top-right-radius: 10px;
}

.flex {
  display: flex;
  align-items: center;
}
.flex .left-max {
  width: 75%;
}
.flex .right-max {
  width: 27%;
  display: flex;
  justify-content: center;
}

.handle-overflow {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 这里是超出几行省略 */
  overflow: hidden;
  line-height: 1.5;
}

.flex .left {
  width: 70%;
  line-height: 24px;
}
.flex .right {
  width: 30%;
  text-align: right;
}
.redMark {
  color: #ef2cff;
  font-size: 9px;
}
.shopMsg {
  width: 143px;
  background: #fff;
  padding: 10px;
  position: absolute;
  top: 0;
  right: 0;
  box-sizing: border-box;
}
.shopMsg p {
  line-height: 24px;
}
.iconStyle {
  width: 16px;
  vertical-align: middle;
}
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ellipsis2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.selectAddress {
  padding: 5px 10px;
  color: #fff;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  position: absolute;
  top: 20px !important;
  left: 20px !important;
}
.selectAddress img {
  width: 16px;
  height: 16px;
}
.defaultDesc {
  animation: defaultDesc linear 1s infinite;
}

@keyframes defaultDesc {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
@-webkit-keyframes defaultDesc {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
a {
  text-decoration: none;
  color: #999999 !important;
  font-size: 14px;
}
.hidden {
  display: none;
}
.maximize {
  position: absolute;
  bottom: 50px;
  right: 10px;
  width: 30px;
  height: 30px;
}
img {
  width: 100%;
}
.mapWrapper {
  position: relative;
}
.shopTips {
  width: 100%;
  line-height: 40px;
  padding-left: 30px;
  background: #fff;
  position: absolute;
  top: 0;
  z-index: 22;
  color: #000000;
  font-size: 16px;
  opacity: 0.8;
}
.shopTips .deleteTips {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 12px;
  right: 15px;
  z-index: 22;
}
.toLocation {
  position: absolute;
  left: 25px;
  bottom: 55px;
  z-index: 22;
  width: 30px;
  height: 30px;
}
.minimize {
  position: absolute;
  right: 25px;
  bottom: 55px;
  z-index: 22;
  width: 30px;
  height: 30px;
  z-index: 19;
}
.shopMsg2 {
  position: absolute;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 170;
  width: 100%;
}
.searchContainer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.3);
  z-index: 11;
  text-align: center;
  page-break-before: always;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.searchContainer .searchContent {
  padding: 10px;
  width: 750px;
}
.searchContainer .headWrapper {
  background: #fff;
  padding: 5px 0;
  border-radius: 3px;
  height: 32px;
  box-sizing: border-box;
}
.searchContainer .headWrapper .left {
  width: 18%;
  text-align: center;
  border-right: 1px solid #eee;
  justify-content: center;
}
.searchContainer .headWrapper .left img {
  width: 10px;
  height: 10px;
  margin-left: 3px;
}
.searchContainer .headWrapper .middle {
  width: 64%;
  border-right: 1px solid #eee;
  position: relative;
}
.searchContainer .headWrapper .middle input {
  width: 100%;
  text-indent: 10px;
  border: none;
  outline: none;
  line-height: 18px;
  font-size: 12px;
}
.searchContainer .headWrapper .right {
  width: 18%;
  text-align: center;
}
.areaWrapper {
  margin-top: 10px;
  padding-top: 10px;
  background: #fff;
  border-radius: 3px;
  position: relative;
}
.areaWrapper .triangle {
  width: 15px;
  position: absolute;
  top: -5px;
  left: 20px;
}
.areaWrapper .location {
  padding-bottom: 10px;
  padding-left: 10px;
}
.areaWrapper .content {
  position: relative;
  line-height: 40px;
  color: #666;
}
.areaWrapper .content .province {
  width: 20%;
  /* height: 204px; */
  overflow: auto;
  min-width: 140px;
  text-align: left;
}
.areaWrapper .content .province::-webkit-scrollbar {
  display: none;
}
.areaWrapper .content .province .item {
  background: #f8f8f8;
}
.areaWrapper .content .province .item .provinceName {
  margin: 0 3px 0 10px;
}
.areaWrapper .content .province .item:last-child .provinceName {
  border: none;
}
.areaWrapper .content .city {
  max-width: calc(100% - 140px);
  width: 80%;
  position: absolute;
  top: 0;
  right: 0;
  background: #fff;
  border-radius: 3px;
  padding: 0 10px;
  box-sizing: border-box;
  /* height: 204px; */
  overflow: auto;
}
.areaWrapper .content .city::-webkit-scrollbar {
  display: none;
}
.areaWrapper .content .city .item {
}
.areaWrapper .content .city .item:last-child {
  border: none;
}
.provinceActive {
  background: #fff !important;
  color: #000;
}
.cityActive {
  border-color: #333;
  color: #000;
}
.betweenFlex {
  display: flex;
  justify-content: space-between;
}
.searchResult {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 33;
  max-width: 750px;
}
.searchWrapper {
  padding: 10px 0;
}
.searchWrapper .left {
  width: auto;
  text-align: center;
  justify-content: center;
  margin: 0 15px 0 10px;
}
.searchWrapper .left img {
  width: 20px;
}
.searchWrapper .middle {
  flex: 1;
  border-radius: 3px;
  background: #f5f5f5;
  position: relative;
}
.searchWrapper .middle .searchImg {
  width: 16px;
  height: 16px;
  margin: 0 10px;
}
.searchWrapper .middle input {
  width: 100%;
  height: 32px;
  background: #f5f5f5;
  border: none;
  outline: none;
  font-size: 12px;
}
.searchWrapper .right {
  width: auto;
  font-size: 14px;
  padding: 0 15px;
}
.searchResult li:first-child {
  border-top: 1px solid #e5e5e5;
}
.noSearchData {
  padding-top: 30%;
  text-align: center;
  color: #000000;
  font-size: 14px;
}
.noSearchData img {
  width: 132px;
}
.gray {
  color: #666;
}
.mtop-10 {
  margin-top: 10px;
}
.mt-10 {
  margin-bottom: 10px;
}
.fs-16 {
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 700;
}
.shopMsg .channel-name {
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 700;
  line-height: 20px;
}
.fs-14 {
  font-size: 14px;
}
.fs-12 {
  font-size: 12px;
}
.bold {
  color: #333333;
  letter-spacing: 0;
  font-weight: 700;
}
.mapbanner {
  bottom: 0;
  text-align: center;
  height: 24vw;
  margin-top: -40px;
  position: relative;
  z-index: 170;
}
.mapbanner img {
  z-index: 1;
  border-radius: 5px;
  width: calc(100% - 30px);
  height: 24vw;
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
.searchResultContainer {
  background-color: #ffffff;
}
.align-left {
  text-align: left;
}
.fixedPage {
  position: fixed;
  top: 0;
  left: 0;
}
.clearIpt {
  position: absolute;
  right: 10px;
  top: 9px;
  width: 14px;
  height: 14px;
}
.customSelect {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e5e5e5;
  font-weight: bold;
}
.customSelect .sortItem {
  position: relative;
  width: 50%;
  text-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #000000;
  line-height: 16px;
  height: 16px;
  margin: 15px 0;
}
.customSelect .current {
  color: #256fff;
}
.customSelect .sortItem span {
  margin-left: 10px;
  width: 0;
  height: 0;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  position: absolute;
  top: 5px;
}
.customSelect .sortItem .downTriangle {
  border-top: 5px solid #000000;
}
.customSelect .current .downTriangle {
  border-top: 5px solid #256fff;
}
.customSelect .sortItem .upTriangle {
  border-bottom: 5px solid #000000;
}
.customSelect .current .upTriangle {
  border-bottom: 5px solid #256fff;
}
.screenWrapper {
  width: 100%;
  height: 400px;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 46px;
  left: 0;
  font-weight: bold;
}
.screenWrapper ul {
  padding: 0 25px;
  background: #fff;
}
.screenWrapper ul li {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.screenWrapper ul li img {
  width: 15px;
}
.activeColor {
  color: #256fff;
}
.experienceShop {
  width: 36px;
  vertical-align: middle;
  margin-top: -4px;
}
.nextStep {
  border: 1px solid rgba(37, 111, 255, 1);
  color: #256fff;
  border-radius: 28px;
  width: 70px;
  text-align: center;
  line-height: 24px;
  font-weight: 500;
  margin: 0 auto;
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: ' ';
  clear: both;
  height: 0;
}
@media (min-width: 750px) {
  .screenWrapper {
    height: 800px;
  }
  .searchResult {
    left: calc(50% - 375px);
  }
  .fixedPage {
    left: calc(50% - 375px);
  }
}

.amap-logo {
  display: none !important;
}
.amap-copyright {
  display: none !important;
}

.errorResponse-open {
  position: fixed;
  right: 0;
  bottom: 81px;
  z-index: 2;
  transition-proprety: right;
  transition-duration: 1s;
}
.errorResponse-close {
  position: fixed;
  right: -52px;
  bottom: 81px;
  z-index: 2;
  transition-proprety: right;
  transition-duration: 1s;
}
.errorResponse img {
  width: 80px;
  height: 26px;
}
.store-type {
  font-size: 12px;
  color: #256fff;
  text-align: center;
  background: #e3ecff;
  padding: 2px;
  line-height: 14px;
  margin-right: 6px;
}
.isChecked {
  border: 2px solid #256fff !important;
  background-color: #fff;
}
.checkedIcon {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 20px;
  height: 20px;
}
.noCheck {
  background-color: #ffffff;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/navigation.vue